/*
 *
 * AnnouncementBarContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import * as actionCreators from './actions';
import AnnouncementBar from './AnnouncementBar';
import makeSelectAnnouncement from './selectors';
import {removeAnnouncement} from "domain/Announcements/actions";


import {openDialog} from "./actions";

class AnnouncementBarContainer extends React.PureComponent {
    render() {
        const {announcement, closeBar, showAnnouncementDialog, removeAnnouncement} = this.props;
        return (
            <AnnouncementBar
                announcement={announcement}
                onClose={closeBar}
                showAnnouncementDialog={showAnnouncementDialog}
                removeAnnouncement={removeAnnouncement}
            />
        );
    }
}

AnnouncementBarContainer.propTypes = {
    announcement: PropTypes.object.isRequired,
    closeBar: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
    announcement: makeSelectAnnouncement(),
});

function mapDispatchToProps(dispatch) {
    return {
        closeBar: () => dispatch(actionCreators.closeBar()),
        removeAnnouncement: (id) => dispatch(removeAnnouncement(id)),
        showAnnouncementDialog: () => dispatch(openDialog())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementBarContainer);
